// TODO: Content Fixes
// ambience musik soll Vogelzwitschern drin haben -> aus Kulissen atmo raus
// K12 loop offset

import GameSceneImage from '../../Inamove/Components/GameSceneImage/GameSceneImage'
import { createInteractableObjectListener } from '../../Inamove/Components/InteractableObject'
import Level, { LevelActionsAction } from '../../Inamove/Components/Level'
import { createTakeableObjectListener } from '../../Inamove/Components/TakeableObject'
import Video from '../../Inamove/Components/Video/Video'
import { waypointOpenActionCreator } from '../../Inamove/Components/Waypoint'
import CinematicContainer from '../../Inamove/Containers/CinematicContainer/CinematicContainer'
import Config from '../../Inamove/Containers/Config'
import GameSceneContainer from '../../Inamove/Containers/GameSceneContainer/GameSceneContainer'
import InventoryContainer from '../../Inamove/Containers/InventoryContainer/InventoryContainer'
import LoadingContainer from '../../Inamove/Containers/LoadingContainer/LoadingContainer'
import AudioController from '../../Inamove/Controllers/AudioController'
import LevelController from '../../Inamove/Controllers/LevelController'
import LoadingController from '../../Inamove/Controllers/LoadingController'
import dispatch from '../../Inamove/Utility/dispatchAction'

export default async function () {
    InventoryContainer.clean()
    CinematicContainer.hide()
    GameSceneContainer.hide()
    LoadingController.reset()
    LoadingContainer.show()

    const V6 = new Video(Config.CINEMATIC_PATH + 'V6' + Config.VIDEO_FILE_EXT)
    CinematicContainer.setVideo(V6)
    LoadingController.addToQueue(V6)

    const level = await LevelController.loadLevel('level3')

    // youtube player in tv
    const youtube = document.createElement('div')
    youtube.classList.add('hidden')
    youtube.classList.add('K10-youtube')
    youtube.innerHTML =
        '<iframe class="K10-youtube-iframe" src="https://www.youtube.com/embed/Zch1Xd--G88" frameborder="0"></iframe>'
    level.gameScenes.K10.element.appendChild(youtube)
    createInteractableObjectListener('fernseher', () => {
        youtube.classList.remove('hidden')
    })

    // load assets for special interactions

    const K11_Schrank_Overlay = new GameSceneImage(Config.GAME_SCENE_PATH + 'K11/K11-Schrank.png')
    const K11_Rucksack_Overlay = new GameSceneImage(Config.GAME_SCENE_PATH + 'K11/K11-Rucksack.png')
    const K12_Rucksack_Overlay = new GameSceneImage(Config.GAME_SCENE_PATH + 'K12/K12-Rucksack.png')
    const K12_Licht_Overlay = new GameSceneImage(Config.GAME_SCENE_PATH + 'K12/K12-Licht.png')

    ;[K11_Schrank_Overlay, K11_Rucksack_Overlay, K12_Rucksack_Overlay, K12_Licht_Overlay].forEach(
        LoadingController.addToQueue
    )

    // Rucksack
    level.gameScenes.K11.addImage(K11_Rucksack_Overlay)
    level.gameScenes.K12.addImage(K12_Rucksack_Overlay)
    const pickedUp_Rucksack = createInteractableObjectListener('rucksack').finally(() => {
        level.gameScenes.K11.removeImage(K11_Rucksack_Overlay, true)
        level.gameScenes.K12.removeImage(K12_Rucksack_Overlay, true)
        level.gameScenes.K11.removeInteractableObject('rucksack')
    })

    // handy in schrank
    const seeMobileAudio = AudioController.add(Config.GAME_SCENE_PATH + 'K11/audio/K11-3A-2' + Config.AUDIO_FILE_EXT)
    let hasHandyAudioBeenPlayed = false
    level.gameScenes.K11.addImage(K11_Schrank_Overlay)
    K11_Schrank_Overlay.hide()
    level.gameScenes.K11.hideTakeableObject('handy')
    level.gameScenes.K11.hideInteractableObject('schublade1')

    createInteractableObjectListener('schublade1', () => {
        const isHandyTaken = InventoryContainer.isItemInInventory('I10')

        if (!isHandyTaken) {
            level.gameScenes.K11.hideTakeableObject('handy')
        }

        K11_Schrank_Overlay.hide()
        level.gameScenes.K11.hideInteractableObject('schublade1')
        level.gameScenes.K11.showInteractableObject('schublade')
    })

    createInteractableObjectListener('schublade', () => {
        const isHandyTaken = InventoryContainer.isItemInInventory('I10')

        if (!isHandyTaken) {
            level.gameScenes.K11.showTakeableObject('handy')
        }

        K11_Schrank_Overlay.show()
        level.gameScenes.K11.hideInteractableObject('schublade')
        level.gameScenes.K11.showInteractableObject('schublade1')

        // play audio once
        if (!hasHandyAudioBeenPlayed) {
            AudioController.play(seeMobileAudio)
            hasHandyAudioBeenPlayed = true
        }
    })

    // switch light off and on
    let isLightOn = false
    const handleLightSwitchInteraction = () => {
        if (isLightOn) {
            level.gameScenes.K12.removeImage(K12_Licht_Overlay)
            isLightOn = false
        } else {
            level.gameScenes.K12.addImage(K12_Licht_Overlay)
            isLightOn = true
        }
    }
    createInteractableObjectListener('lampe', handleLightSwitchInteraction)

    await AudioController.addAllToLoadingQueue()

    await LoadingController.processQueue()
    await LoadingContainer.clickStart()

    GameSceneContainer.hide()
    InventoryContainer.hide()
    CinematicContainer.show()
    LoadingContainer.hide()

    await CinematicContainer.play()

    CinematicContainer.hide()
    GameSceneContainer.show()
    LevelController.startLevel('level3')

    // wait until all necessary items have been picked up
    await Promise.all([
        createTakeableObjectListener('backpulver'),
        createTakeableObjectListener('dvd'),
        createTakeableObjectListener('notizzettel'),
        createTakeableObjectListener('euro'),
        createTakeableObjectListener('stift'),
        createTakeableObjectListener('shirt'),
        createTakeableObjectListener('haarnadel'),
        createTakeableObjectListener('handy'),
        pickedUp_Rucksack,
    ])

    dispatch(waypointOpenActionCreator('level4'))

    return new Promise<void>((resolve) => {
        addEventListener('Level', (event) => {
            // @ts-ignore
            const action: LevelActionsAction = event.detail.action
            // @ts-ignore
            const level: Level = event.detail.level

            if (action === LevelActionsAction.stop && level.id === 'level3') {
                resolve()
                level.destroy()
            }
        })
    })
}
